var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.5C0.5 4.97953 4.97953 0.5 10.5 0.5C16.0205 0.5 20.5 4.97953 20.5 10.5C20.5 16.0205 16.0205 20.5 10.5 20.5C4.97953 20.5 0.5 16.0205 0.5 10.5ZM2.16667 10.5C2.16667 5.9 5.9 2.16667 10.5 2.16667C15.1 2.16667 18.8333 5.9 18.8333 10.5C18.8333 15.1 15.1 18.8333 10.5 18.8333C5.9 18.8333 2.16667 15.1 2.16667 10.5ZM9.66667 13V14.6667H11.3333V13H9.66667ZM9.66667 11.3333H11.3333V6.33333H9.66667V11.3333Z",
    fill: "#FF7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.baac68c11626fed55fd8d815b0d2dafc.svg";
export { ForwardRef as ReactComponent };